import { IDeviceCategoryEnum } from "@backend/src/shared/schemas/foundationSchema";
import { DEVICES_TYPES_SETTINGS } from "@multiconsult-group/multiplacer-core";

const DeviceIcon: React.FC<{ deviceType: IDeviceCategoryEnum | undefined }> = ({ deviceType }) => {
  const color = deviceType != null ? DEVICES_TYPES_SETTINGS[deviceType]?.color || "#CCC" : "#CCC";

  return <div style={{ height: "10px", width: "10px", backgroundColor: color }} />;
};

export default DeviceIcon;
